module.exports = "https://cdn.dove.it/_next/static/public/assets/cities/small/catania.99cd65a48c15649993bff7ff8547dccf.jpg";